export default "__VITE_ASSET__DkRN7DFb__"